import { ThemeConfig } from 'antd';

export const theme: Partial<ThemeConfig> = {
  token: {
    colorPrimary: '#7f56d9',
    colorTextBase: '#101828',
    colorInfo: '#7f56d9',
  },
};
